/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ModalImageDash from '../../../../components/NovoSistema/ModalImageDash';

export default function TemplateMandala() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/mandala/';
  const nameImage = 'logo-mandala';
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Mandala" linkIcon="/images/icons/mandala.svg" />
        <img
          onClick={() => setOpenModal(true)}
          src={`${prefix}${nameImage}.png`}
          alt={nameImage}
          style={{ maxWidth: '1200px', width: '100%' }}
        />
        {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
